import { createContext } from "react";
import { ReactNode } from "react";

export interface LayoutContextType {
  pageTitle: string;
  setPageTitle: (title: string) => void;
  pageExtra: ReactNode | null;
  setPageExtra: (extra: ReactNode | null) => void;
}

const LayoutContext = createContext<LayoutContextType>({
  pageTitle: "",
  setPageTitle: () => {},
  pageExtra: null,
  setPageExtra: () => {},
});

export default LayoutContext;
